import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

/**
 * Тема — фирменная (statuspro-red + bast-blue + bast-night).
 * Делаем dark по умолчанию: админка визуально консистентна с лендингом.
 */
export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'influenceDark',
    themes: {
      influenceDark: {
        dark: true,
        colors: {
          background: '#0a0a0a',
          surface: '#141414',
          'surface-variant': '#1f1f1f',
          primary: '#e11d48', // statuspro-red
          secondary: '#2563eb', // bast-blue
          accent: '#3b82f6',
          error: '#ef4444',
          warning: '#f59e0b',
          info: '#3b82f6',
          success: '#10b981',
          'on-background': '#ffffff',
          'on-surface': '#f5f5f5',
          'on-primary': '#ffffff',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  defaults: {
    VBtn: {
      style: 'text-transform: none; font-weight: 600; letter-spacing: 0',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      hideDetails: 'auto',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      hideDetails: 'auto',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      hideDetails: 'auto',
    },
    VCard: {
      rounded: 'lg',
    },
    VChip: {
      // Из memory feedback_vuetify_chip_contrast — tonal сам подбирает яркий текст
      variant: 'tonal',
    },
  },
})
